import { PartyPopper, Heart, Clover, Flag, Sparkles, Ghost, Drumstick, TreePine } from "lucide-react";

const nthWeekday = (year, month, weekday, n) => {
  let count = 0;
  for (let d = 1; d <= 31; d++) {
    const dt = new Date(year, month, d);
    if (dt.getMonth() !== month) break;
    if (dt.getDay() === weekday) {
      count += 1;
      if (count === n) return d;
    }
  }
  return -1;
};

const lastWeekday = (year, month, weekday) => {
  const dt = new Date(year, month + 1, 0); // last day of month
  while (dt.getDay() !== weekday) dt.setDate(dt.getDate() - 1);
  return dt.getDate();
};

// Returns { label, Icon } for major US holidays, else null. weekday: Sun=0 ... Sat=6
export function getHoliday(date) {
  const y = date.getFullYear();
  const m = date.getMonth(); // 0-indexed
  const d = date.getDate();

  if (m === 0 && d === 1) return { label: "New Year's Day", Icon: PartyPopper };
  if (m === 1 && d === 14) return { label: "Valentine's Day", Icon: Heart };
  if (m === 2 && d === 17) return { label: "St. Patrick's Day", Icon: Clover };
  if (m === 4 && d === lastWeekday(y, 4, 1)) return { label: "Memorial Day", Icon: Flag };
  if (m === 6 && d === 4) return { label: "Independence Day", Icon: Sparkles };
  if (m === 8 && d === nthWeekday(y, 8, 1, 1)) return { label: "Labor Day", Icon: Flag };
  if (m === 9 && d === 31) return { label: "Halloween", Icon: Ghost };
  if (m === 10 && d === 11) return { label: "Veterans Day", Icon: Flag };
  if (m === 10 && d === nthWeekday(y, 10, 4, 4)) return { label: "Thanksgiving", Icon: Drumstick };
  if (m === 11 && d === 24) return { label: "Christmas Eve", Icon: TreePine };
  if (m === 11 && d === 25) return { label: "Christmas Day", Icon: TreePine };
  if (m === 11 && d === 31) return { label: "New Year's Eve", Icon: PartyPopper };

  return null;
}
